export default __webpack_public_path__ + "static/media/dashboard.65e71043.svg";